/**
* @Property mappings for the remote commands
**/
export const remote_mappings = {
  'door-unlock': 'Remote Door Unlock ',
  'dunlock': 'Remote Door Unlock ',
  'du': 'Remote Door Unlock ',
  'door-lock': 'Remote Door Lock ',
  'dlock': 'Remote Door Lock ',
  'dl': 'Remote Door Lock ',
  'engine-start': 'Remote Engine Start ',
  'estart': 'Remote Engine Start ',
  'res': 'Remote Engine Start ',
  'engine-stop': 'Remote Engine Stop ',
  'estop': 'Remote Engine Stop ',
  'rest': 'Remote Engine Stop ',
  'hazard-off': 'Remote Hazard Off ',
  'hzoff': 'Remote Hazard Off ',
  'hazard-on': 'Remote Hazard On ',
  'hzon': 'Remote Hazard On ',
  'power-window-close': 'Remote Power Window Close ',
  'refresh-status': 'Remote Refresh Status ',
  'guest-profile-activate': 'Remote Guest Profile Activate ',
  'guest-profile-deactivate': 'Remote Guest Profile Deactivate ',
  'sound-horn': 'Remote Sound Horn ',
  'buzzer-warning': 'Remote Buzzer Warning ',
  'find-vehicle': 'Remote Find Vehicle ',
  'headlight-on': 'Remote Headlight On ',
  'dwake': 'Remote Door Wake ',
  'ewake': 'Remote Engine Wake ',
  'hzwake': 'Remote Hazard Wake ',
  'rts': 'Remote Real Time Status ',
  'ac-on': 'Remote AC On',
  'ac-off': 'Remote AC Off',
  'reserve-charge': 'Remote Reserve Charge',
  'immediate-charge': 'Remote Immediate Charge',
  'power-supply-off': 'Remote Power Supply Off',
  'realtimestatus': 'Remote Real Time Status',
  'LegacyRealTimeStatus': 'Remote Legacy Real Time Status',
  'create-charge-timer-schedule': 'Remote Create Charge Timer Schedule',
  'update-charge-timer-schedule': 'Remote Update Charge Timer Schedule',
  'delete-charge-timer-schedule': 'Remote Delete Charge Timer Schedule',
  'remotecommand':'Remote Command',
  'remotecontrol legacy':'Remote Control Legacy',
  'remotecontrol 17cy plus': 'Remote Control 17CY Plus',
  'evacreservecommand': 'EV AC Reserve Command',
  'acreservation':'AC Reservation',
  'vehiclestatus': 'Vehicle Status',
  'realtimevehiclestatus':'Real Time Vehicle Status',
  'commandexecutionvehiclestatus':'Command Execution Vehicle Status',
  'espostatus': 'ESPO Status',
  'evespoinfotype':'EV ESPO Info Type',
  'specbevresultCode':'Spec B EV Result Code',
  'errorcategory':'Error Category',
  'tsc error':'TSC Error',
  'cache error':'Cache Error',
  'mongodb error':'MongoDB Error',
  'specbevresultmessage':'Spec B EV Result Message',
  'correlationid':'Correlation Id',
  'tscresponseev':'TSC Response EV',
  'ctpresponseev':'CTP Response EV',
  'evaccommand': 'EV AC Command',
  'remotecommandlegacy':'Remote Command Legacy',
  'remotecommandfor17cyplus':'Remote Command For 17CYPlus',
  'evchargecommand':'EV Charge Command',
  'evpowercommand':'EV Power Command',
  'ac switch on':'AC Switch On',
  'ac switch off':'AC Switch Off',
  'charge start':'Charge Start',
  'reservation charge':'Reservation Charge',
  'stop power supply':'Stop Power Supply',
  'km':'Km',
  'notificationresponse':'Notification Response',
  'eveconnectadaptereventnotification': 'EV  EConnect Adapter Event Notification',
  'eveconnectadapterlegacyeventnotification':'EV EConnect Adapter Legacy Event Notification',
  'econnectstatuschangenotification':'EConnect Status Change Notification',
  'speccevresultcode':'Spec C EV Result Code',
  'retrievevehiclerealtimestatus':'Retrieve Vehicle Real time Status',
  'createvehicleacreservation':'Create Vehicle AC Reservation',
  'updatevehicleacreservation':'Update Vehicle AC Reservation',
  'deletevehicleacreservation': 'Delete Vehicle AC Reservation',
  'remotecontrolcallback':'Remote Control Callback',
  'acreservationcallback':'AC Reservation Callback',
  'evcallbackrequestno':'EV Callback Request No',
  'notification error':'Notification Error',
  'speccevresultmessage':'Spec C EV Result Message'



};
